import React from 'react';
import {Box, Checkbox, FormControlLabel} from '@mui/material';

import {CheckboxChecked, CheckboxUnchecked} from '@icons/index';

interface CustomCheckboxProps {
  handleChange?: (checked: boolean) => void;
  readOnly?: boolean;
  value?: boolean;
}

const CustomCheckbox = (props: CustomCheckboxProps) => {
  const {handleChange, readOnly, value} = props;

  return (
    <Checkbox
      onChange={handleChange ? (evt, checked) => handleChange(checked) : undefined}
      value={value}
      checked={value}
      readOnly={readOnly}
      checkedIcon={<CheckboxChecked/>}
      icon={<CheckboxUnchecked/>}/>
  );
};

interface CheckboxComponentProps {
  handleChange?: (checked: boolean) => void;
  label?: string;
  labelPlacement?: 'start' | 'end';
  labelWidth?: number;
  readOnly?: boolean;
  value?: boolean;
}

const CheckboxComponent = (props: CheckboxComponentProps) => {
  const {handleChange, label, labelPlacement = 'start', labelWidth, readOnly, value} = props;

  if (!label) {
    return (
      <CustomCheckbox readOnly={readOnly}/>
    );
  }

  return (
    <Box>
      <FormControlLabel
        disabled={readOnly}
        checked={value}
        control={<CustomCheckbox value={value} handleChange={(checked) => handleChange?.(checked)}/>}
        sx={{'& .MuiFormControlLabel-label': {width: labelWidth ? `${labelWidth}px` : undefined}}}
        labelPlacement={labelPlacement}
        label={label}/>
    </Box>
  );
};

export default CheckboxComponent;
